<template>
  <div class="studentBatchCreate">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'student', params: {} }">
        Student
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :to="{ name: 'studentCreate', params: {} }">
        Create Student (Batch)
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card class="py-10">
      <v-card-title>Student Batch Upload</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-select
            class="mx-2"
            label="Location"
            v-model="selectedCenterId"
            :items="availableCenters"
            item-text="name"
            item-value="id"
            :rules="[rules.required]"
          />

          <v-file-input
            class="mr-2"
            label="Choose student spreadsheet (CSV format)"
            v-model="csvFile"
            :rules="[rules.required]"
          />
        </v-form>
        <pre class="ma-2" style="white-space: pre-wrap; ">
Below are the supported columns on the importing spreadsheet (The ordering doesn't matter, however column names are case sensitive and must be exact):

- First Name
- Last Name
- Gender (Supported option are F, Female, M, or Male)
- Grade
- DoB
- Type (Supported options are: {{
            contactTypes ? contactTypes.map(t => t.name).join(", ") : ""
          }})
- Student ID
- Status ('Active' or 'Inactive')
</pre
        >
      </v-card-text>
      <v-card-actions>
        <v-btn @click="goBack"> Back </v-btn>
        <v-spacer />
        <v-btn color="primary" :disabled="loading" @click="uploadStudents"
          >Upload</v-btn
        >
        <v-spacer />
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import csv from "csvtojson";
import { mapActions, mapGetters } from "vuex";
import { getAllContactTypes } from "@/services/contactType";
import Axios from "axios";
import moment from "moment";
import { rules } from "@/store/util/rules.js";

export default {
  name: "studentBatchUpload",
  data: () => {
    return {
            valid: false,
      csvFile: null,
      contactTypes: null,
      selectedCenterId: null,
      loading: false,
      rules
    };
  },
  computed: {
    ...mapGetters("auth", ["myCenters"]),
    ...mapGetters("navigation", ["globalCenter"]),
    availableCenters() {
      if (this.myCenters && this.myCenters.length > 0) {
        return this.myCenters.filter(c => c.id != null);
      } else {
        return [];
      }
    }
  },
  created() {
    this.$emit("showParent", false);
    this.initContactTypes();
  },
  methods: {
    ...mapActions("student", ["createStudent", "updateStudent"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),
    initContactTypes() {
      const params_target = {
        page: 0,
        size: 100
      };
      getAllContactTypes(params_target).then(response => {
        this.contactTypes = response.data.content;
      });
    },
    uploadStudents() {
      if (!this.$refs.form.validate()) {
        this.addErrorMessage("Please check your inputs");
        return;
      }

      this.loading = true;

      var fileTypes = ["csv"]; //acceptable file types
      var extension = this.csvFile.name
          .split(".")
          .pop()
          .toLowerCase(), //file extension from input file
        isAcceptable = fileTypes.indexOf(extension) > -1; //is extension in acceptable types

      if (!isAcceptable) {
        this.addErrorMessage(
          "Invalid file detected, please choose a .csv file"
        );
        return;
      }

      var reader = new FileReader();

      reader.onload = () => {
        const csvStr = reader.result;

        csv()
          .fromString(csvStr)
          .then(csvRows => {
            const supportedRows = csvRows.filter(row => {
              const contactType = this.contactTypes.includes(
                row["Contact Type"]
              );
              return contactType != null;
            });

            this.uploadRows(supportedRows)
              .then(successCount => {
                this.addSuccessMessage(`Upload ${successCount} students`);
                this.loading = false;
              })
              .catch((error) => {
                this.addErrorMessage("Error uploading file: " + error);
                this.loading = false;
              });
          });
      };

      reader.readAsBinaryString(this.csvFile);
    },
    async uploadRows(rows) {
      let axiosRequests = null;
      try{
        axiosRequests = this.prepCreateStudentRequests(rows);
      }
      catch(error) {
        throw error.message
      }

      return await Axios.all(axiosRequests).then(
        Axios.spread((...responses) => {
          let count = 0;
          responses.forEach(resp => {
            if (resp.data) {
              count++;
              console.log("saved student ...");
            }
          });

          return count;
        })
      );
    },
    prepCreateStudentRequests(rows) {
      if (rows && rows.length > 0) {
        //validate row types
        const array = rows.map(r => r["Type"]);
        const acceptable = this.contactTypes.map(ct => ct.name).join(", ");
        let uniqueTypes = [...new Set(array)];
        const notAcceptable = uniqueTypes.filter(u => !acceptable.includes(u));
        if(notAcceptable && notAcceptable.length > 0){
          throw new Error(`Type "${notAcceptable.join(", ")}" is not recognizable; acceptable types are: ${acceptable}`)
        }

        return rows.map(row => {
          const rowType = row["Type"] ? row["Type"].trim():null;
          const type = rowType ? this.contactTypes.find(ct => ct.name == rowType) : null;
          const contactTypeId = type.id;
          let dob = row["DoB"];
          if (dob) {
            dob = moment(dob).format("YYYY-MM-DD");
          }

          let gender = row["Gender"];
          gender = gender.toLowerCase() == 'f' || gender.toLowerCase() == 'female' ? 'Female':'Male';

          const active = row['Status'] === 'Active' ? true: false;

          const student = {
            centerId: this.selectedCenterId,
            contactTypeId,
            firstName: row["First Name"],
            lastName: row["Last Name"],
            clientStudentId: row["Student ID"],
            gender,
            grade: row["Grade"],
            dob,
            active
          };
          return this.createStudent(student);
        });
      } else {
        return [];
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
